import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ActionItemList as OldActionItemList } from '@modernhealth/vital-components';

import timerIcon from 'src/public/img/timer-in-circle.svg';
import walletIcon from 'src/public/img/wallet-in-circle.svg';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { StaticItemList } from './StaticItemList';

type Props = {
    sessionDate: string;
    sessionCost: string;
    onDateClick: () => void;
    onCostClick: () => void;
    isCostDisabled: boolean;
    isDateDisabled: boolean;
};

export const SessionReviewItemsList: React.FC<Props> = ({
    sessionDate,
    sessionCost,
    onDateClick,
    onCostClick,
    isCostDisabled,
    isDateDisabled,
}) => {
    const { heatCostTransparency } = useFlags();
    const { t } = useTranslation();

    return (
        <>
            {heatCostTransparency ? (
                <StaticItemList
                    items={[
                        {
                            iconName: 'calendar',
                            title: sessionDate,
                            isMarginTopVisible: false,
                        },
                        {
                            iconUrl: walletIcon,
                            title: (
                                <Trans
                                    t={t}
                                    ns="payments"
                                    i18nKey="session_review.review_items.cost_v2"
                                    values={{
                                        cost: sessionCost,
                                    }}
                                    components={{
                                        right: <span />,
                                    }}
                                />
                            ),
                            description: t('payments:session_review.review_items.cost_description'),
                            onDescriptionLinkClick: onCostClick,
                            descriptionLinkCta: t(
                                'payments:session_review.review_items.cost_description_cta',
                            ),
                        },
                    ]}
                />
            ) : (
                <OldActionItemList
                    actions={[
                        {
                            disabled: isDateDisabled,
                            id: 'sessionDate',
                            startIconUrl: timerIcon,
                            title: sessionDate,
                            onClick: isDateDisabled ? undefined : onDateClick,
                            withBorder: true,
                        },
                        {
                            disabled: isCostDisabled,
                            id: 'sessionCost',
                            startIconUrl: walletIcon,
                            title: t('payments:session_review.review_items.cost', {
                                cost: sessionCost,
                            }),
                            onClick: isCostDisabled ? undefined : onCostClick,
                            withBorder: true,
                        },
                    ]}
                />
            )}
        </>
    );
};
